import './Dashboard.css';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';

function Dashboard() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleSidebarCollapse = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  return (
    <div className="dashboard-layout">
      <Navbar onSidebarCollapse={handleSidebarCollapse} />

      <div className={`dashboard-body ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <main className="dashboard-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
